import React from 'react';
import TokenWithNetwork from '../../../../../Common/TokenWithNetwork/TokenWithNetwork';
import { getValueByMultiProps } from '../../../../../../utils/mapper';
import SignStatus from '../SignStatus/SignStatus';
import { mapOrderType } from '../../../../../../services/hpoolService';

const parseTokenName = (token) => {
  const tokenName = token?.token_pair;
  const [from, to] = tokenName.split('/');
  return { from, to };
};

/* eslint-disable react/prop-types */
export const singleTradeOrderCols = (orderType, { signMethod, loading }) => [
  {
    id: 'baseTokenInfo',
    title: mapOrderType(orderType),
    render: (token, baseTokenInfo) => (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <TokenWithNetwork
          token={{
            ...baseTokenInfo,
            image: getValueByMultiProps(baseTokenInfo, ['img']),
          }}
        />
        <span className="mx-3">{baseTokenInfo?.name}</span>
      </div>
    ),
  },
  {
    id: 'token_ratio',
    title: 'Amount',
    render: (record, ratio = 0) => <>{ratio || 0}%</>,
  },
  {
    id: 'forTokenInfo',
    title: 'For',
    render: (token, forTokenInfo) => (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <TokenWithNetwork
          token={{
            ...token,
            image: getValueByMultiProps(forTokenInfo, ['img']),
          }}
        />
        <span className="mx-3">{forTokenInfo?.name}</span>
      </div>
    ),
  },
  {
    id: '_status',
    title: '',
    render: (record) => (
      <SignStatus
        tokenAddress={record.token_address}
        tokenRatio={record.percentage}
        tokenId={record.token_id}
        isExecuted={record.is_executed}
        tradeOrderId={record.id}
        token={record}
        signatureType="TradeOrder"
        loading={loading}
        signMethod={signMethod}
      />
    ),
  },
];
